import { Input as AntdInput, Select as AntdSelect, Slider as AntdSlider, InputNumber, Button } from "antd";

const formatCurrencyValue = (value, currency) => {
	if (value === undefined || value === null || value === "") return `${currency} `;
	const num = Math.round(Number(value) * 100) / 100;
	const [intPart, decPart] = num.toString().split(".");
	const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
	const decimal = decPart != null ? "," + decPart.slice(0, 2) : "";
	return `${currency} ${formattedInt}${decimal}`;
};

export const Input = ({ value, onChange, currency, isDisabledProperty = false }) => (
	<div className="container-input-financing">
		<Button
			className="minus"
			disabled={value === 0}
			onClick={() => onChange(value, "minus")}
		>-</Button>
		<Button
			className="plus"
			onClick={() => onChange(value, "plus")}
		>+</Button>
		<InputNumber
			disabled={isDisabledProperty}
			value={value}
			min={0}
			formatter={value => formatCurrencyValue(value, currency)}
			parser={value => {
				const cleaned = value.replace(`${currency} `, "").replace(/\./g, "").replace(",", ".");
				const num = parseFloat(cleaned);
				return isNaN(num) ? 0 : num;
			}}
			onChange={(value) => onChange(value)}
			style={{ width: "100%" }}
			className="custom-input-number"
		/>
	</div>
);

export const InputWithPercentage = ({
	value,
	max,
	percentage,
	onChange,
	currency,
	isDisabledProperty = false,
}) => {
	const changePercentage = newPercentage => {
		if (typeof newPercentage === "number") {
			let newValue = Math.round((newPercentage * max) / 100);
			onChange(newValue);
		}
	};

	return (
		<AntdInput.Group compact style={{ display: "flex" }} className="container-input-percentage">
			<InputNumber
				disabled={isDisabledProperty}
				onChange={changePercentage}
				value={percentage}
				min={0}
				max={100}
				formatter={value => `${value}%`}
				parser={value => value.replace("%", "")}
				style={{ width: "25%", textAlign: "right" }}
				className="input-percentage"
			/>
			<div className="container-input-financing percentage" style={{ width: "75%" }}>
				<Button
					className="minus"
					disabled={value === 0}
					onClick={() => onChange(value, "minus")}
				>-</Button>
				<Button
					className="plus"
					disabled={value === max}
					onClick={() => onChange(value, "plus")}
				>+</Button>
				<InputNumber
					disabled={isDisabledProperty}
					value={value}
					min={0}
					max={max}
					onChange={(value) => onChange(value)}
					formatter={value => formatCurrencyValue(value, currency)}
					parser={value => {
						const cleaned = value.replace(`${currency} `, "").replace(/\./g, "").replace(",", ".");
						const num = parseFloat(cleaned);
						return isNaN(num) ? 0 : num;
					}}
					style={{ width: "100%" }}
				/>
			</div>
		</AntdInput.Group>
	);
};

export const Select = ({ options, value, onChange, isDisabledProperty = false }) => {
	const { Option } = AntdSelect;

	return (
		<AntdSelect
			disabled={isDisabledProperty}
			value={value}
			onChange={onChange}
			style={{ width: "100%" }}>
			{options.map((option, i) => (
				<Option key={"financing_input_" + i + "_" + option.value} value={option.value} disabled={option.disabled ?? false}>
					{option.text}
				</Option>
			))}
		</AntdSelect>
	);
};

export const Slider = ({ value, max, onChange }) => {
	return <AntdSlider style={{ marginTop: 10 }} value={value} max={max} onChange={onChange} />;
};
